import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppointmentSection"] */ "/vercel/path0/src/components/sections/appointment-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FaqSection"] */ "/vercel/path0/src/components/sections/faq-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OffersSection"] */ "/vercel/path0/src/components/sections/offers-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortfolioPreviewSection"] */ "/vercel/path0/src/components/sections/portfolio-preview-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/sections/reviews-recommendations-section.tsx");
